import Vue from 'vue'

const DEFAULT_SORT_BY = 'created_at'
const DEFAULT_SORT_DESC = true

const state = {
  hideIgnored: true,
  hideClosed: false,
  sortBy: DEFAULT_SORT_BY,
  sortDesc: DEFAULT_SORT_DESC,
  userFilter: null,
  selectedAdvisor: null
}

const getters = {}

const mutations = {
  setHideIgnored (state, value) {
    Vue.set(state, 'hideIgnored', value)
  },
  setHideClosed (state, value) {
    Vue.set(state, 'hideClosed', value)
  },
  setSortBy (state, value) {
    Vue.set(state, 'sortBy', value)
  },
  setSortDesc (state, value) {
    Vue.set(state, 'sortDesc', value)
  },
  resetSort (state) {
    Vue.set(state, 'sortBy', DEFAULT_SORT_BY)
    Vue.set(state, 'sortDesc', DEFAULT_SORT_DESC)
  },
  setAdvisor (state, user) {
    Vue.set(state, 'userFilter', user ? user.id : null)
    Vue.set(state, 'selectedAdvisor', user || null)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions: {},
  mutations
}